import type { VoidFunctionComponent } from 'react';

import { SearchInput } from '../../../../../../../../generic';

type Props = {
  onProjectSearch: (search: string) => void;
  projectSearch: string;
};

const ProjectsTableSearchBar: VoidFunctionComponent<Props> = (props) => {
  return (
    <SearchInput
      label="Search projects"
      placeholder="Search projects"
      value={props.projectSearch}
      onChange={props.onProjectSearch}
    />
  );
};

export default ProjectsTableSearchBar;
